import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

const styles = () => ({
  flex: {
    flexGrow: 1,
  },
  footer: {
    padding: 5,
    position: 'absolute',
    textAlign: 'center',
    left: 0,
    bottom: 0,
    right: 0,

    backgroundColor: '#0073a8',
  },
  root: {
    color: '#fff',
    backgroundColor: '#0073a8',
  },
  link: {
    paddingTop: 10,
  },
});

export class Footer extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Paper className={classes.footer}>
          <Grid container spacing={8}>
            <AppBar position="static" className={classes.root}>
              <Toolbar variant="dense">
                <Typography variant="caption" className={classes.flex}>
                  {this.props.isAuthenticated && (
                    <div className={classes.link}>
                      <p>
                        Contact us @{' '}
                        <a
                          style={{ color: 'white' }}
                          href={
                            'mailto:' +
                            'DepositAdministration-QA.SharedMailbox@fplqa.com'
                          }
                        >
                          {' '}
                          FPL Deposit Administration
                        </a>
                      </p>
                    </div>
                  )}
                  Copyright © 1996 - {moment().year()}, Florida Power & Light
                  Company. All rights reserved.
                  <br />
                  Non-Cash Deposit Portal is optimized for the following
                  browsers : IE 9+, Firefox 31+, Chrome 37+, Safari 6.1+.
                </Typography>
                <Typography variant="caption"></Typography>
              </Toolbar>
            </AppBar>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}
Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool,
};

export default withStyles(styles)(Footer);
